<template>
  <div style="height: 100%">
    <label style="padding: 20px 0px 10px 30px;">机房温湿度</label>
    <el-carousel v-if="tempHumidityData.length>0" :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0">
      <el-carousel-item :key="item.spaceId" v-for="item in tempHumidityData">
        <el-row style="text-align: center">
          <label @touchstart="skipOverview(item)"  @click="skipOverview(item)"
                 class="pointer"
                 style="line-height: 3.5vh;color: #fff;"> {{ item.spaceName }} </label>
        </el-row>
        <!--温湿度-->
        <el-row style="height: 50%;padding-top: 35px;">
          <el-col :span="12">
            <el-col :span="12" style="height:7vh;text-align: right;padding-right: 8px;margin-top: 0.8vh;">
              <img src="../../assets/images/index/temperature_2.png" style="height: 100%">
            </el-col>
            <el-col :span="12">
              <div class="temperature" style="color: #32CFD2;font-size: 1.7rem;">
                {{ item.tempAvg === 0 ? '-' : item.tempAvg }}℃
              </div>
              <div style="font-size: 0.8rem">温度</div>
            </el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="5" style="height:7vh;text-align: left;margin-top: 1.3vh;"><img
              src="../../assets/images/index/humidity_1.png" style="height: 100%"></el-col>
            <el-col :span="12">
              <div class="humidity" style="color: #32CFD2;font-size: 1.7rem;">
                {{ item.humiAvg === 0 ? '-' : item.humiAvg }}%
              </div>
              <div style="font-size: 0.8rem">湿度</div>
            </el-col>
          </el-col>
        </el-row>
        <!--温湿度趋势-->
        <el-row style="height: 50%;">
          <label style="font-weight: bold;margin-left: 35px;">温湿度趋势</label>
          <line-chart :data="item.tempHumidityTrendData" :extendData="extendData" ref="lineChart"
                      v-if="item.tempHumidityTrendData"
                      style="height: 80%;"></line-chart>
          <no-data v-else></no-data>
        </el-row>
      </el-carousel-item>
    </el-carousel>
    <div v-else style="height: 100%;padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/echarts/LineChart";
import {getTemperatureAndHumidity} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "controlRoomHumiture",
  mixins: [platenLayoutEdit],
  components: {LineChart, NoData},
  data() {
    return {
      tempHumidityData: [],
      extendData: null,
      deviceInfo: {}
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getData:10000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getData')
  },
  methods: {
    getData() {
      getTemperatureAndHumidity().then(res => {
        if (res.code === 0) {
          this.tempHumidityData = res.data.map(item => {
            item.tempHumidityTrendData = {
              humidity: item.humidity,
              temperature: item.temperature,
              time: item.time
            };
            return item;
          })
        }
      })
    },
    skipOverview(spaceInfo) {
      if (this.isPlatenLayoutEditing) return
      this.deviceInfo.spaceId = spaceInfo.spaceId;
      this.deviceInfo.spaceName = spaceInfo.spaceName
      this.$emit('skipOverview', this.deviceInfo, 'environment_category_tag')
    }
  }
}
</script>

<style scoped>

label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>
